// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { RootState } from "../services/store";
// interface User {
//   id: string;
//   name: string;
//   email: string;
//   account_type?: string;
//   is_head_of_org?: boolean;
//   branches?: { id: string; name: string }[];
//   role?: string | { name: string };
//   user_name?: string;
//   is_2fa_enabled?: number;
//   profile_image?: string;
//   has_branch?: number;
//   preference?: { notify_email?: number; notify_inapp?: number };

//   company?: {
//     id: string;
//     name: string;
//     company_logo?: string;
//     subscription_status?: string;
//     latestSubscription_plan?: {
//       id: string;
//       name: string;
//       duration_days: number;
//     };
//   };

// }
// interface AuthState {
//   token: string;
//   user: User | null;
//   admin: any | null;
//   permissions: string[];
//   isAdmin: boolean;
// }

// const initialState: AuthState = {
//   token: "",
//   user: null,
//   admin: null,
//   permissions: [],
//   isAdmin: false,
// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     setAuthUser: (
//       state,
//       action: PayloadAction<{ token: string; user?: any; admin?: any }>
//     ) => {
//       const payloadUser = action.payload.user;

//       state.token = action.payload.token;
//       state.user = payloadUser
//         ? {
//           id: payloadUser.id || "",
//           name: payloadUser.name || "",
//           email: payloadUser.email || "",
//           account_type: payloadUser.account_type || "individual",
//           is_head_of_org: payloadUser.is_head_of_org || false,
//           branches: payloadUser.branches || [],
//           role: payloadUser.role || "",
//           user_name: payloadUser.user_name || "",
//           is_2fa_enabled: payloadUser.is_2fa_enabled ?? 0,
//           profile_image: payloadUser.profile_image || "",
//           preference: payloadUser.preference || { notify_email: 0, notify_inapp: 0 },
//           has_branch: payloadUser.has_branch ?? 0,
//           company: payloadUser.company || null,
//         }
//         : null;

//       state.admin = action.payload.admin ?? null;
//       state.permissions = payloadUser?.permissions?.map((p: any) => p.name) || [];
//       state.isAdmin = !!payloadUser?.is_head_of_org && payloadUser.is_head_of_org === payloadUser.id;
//     },
//     clearAuthUser: (state) => {
//       state.token = "";
//       state.user = null;
//       state.admin = null;
//       state.permissions = [];
//       state.isAdmin = false;
//     },
//   },
// });

// // selectors
// export const { setAuthUser, clearAuthUser } = authSlice.actions;
// export const authSliceReducer = authSlice.reducer;

// export const selectUser = (state: RootState) => state.auth.user;
// export const selectAdmin = (state: RootState) => state.auth.admin;
// export const selectToken = (state: RootState) => state.auth.token;
// export const selectPermissions = (state: RootState) => state.auth.permissions;
// export const selectIsAdmin = (state: RootState) => state.auth.isAdmin;
// export const selectAuthUser = (state: RootState) => state.auth;
// export const selectAuth = (state: RootState) => state.auth;
// //console.log("state.auth", state.auth)





import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../services/store";



interface UserRole {
  id?: string;
  name: string;
}
interface User {
  id: string;
  name: string;
  email: string;
  account_type?: string;
  is_head_of_org?: boolean;
  branches?: { id: string; name: string }[];
  // role?: string | { name: string };
  role?: UserRole | null;
  user_name?: string;
  is_2fa_enabled?: number;
  profile_image?: string;
  has_branch?: number;
  kyc_verification?: boolean;
  is_feedback_popup?: boolean;
  preference?: { notify_email?: number; notify_inapp?: number };
  company?: {
    id: string;
    name: string;
    company_logo?: string;
    subscription_status?: string;
    kyc_verification?: boolean;
    kyc_status?: string | null;
    latestSubscription_plan?: {
      id: string;
      name: string;
      duration_days: number;
    };
  } | null;
}

interface AuthState {
  token: string;
  user: User | null;
  admin: any | null;
  permissions: string[];
  isAdmin: boolean;
}

const initialState: AuthState = {
  token: "",
  user: null,
  admin: null,
  permissions: [],
  isAdmin: false,
};

// Normalize any account_type value (ULID or name string) to "company" | "individual"
const resolveAccountType = (raw: string | undefined): "company" | "individual" => {
  if (!raw) return "individual";
  const lower = raw.toLowerCase();
  if (lower === "company" || lower.startsWith("org")) return "company";
  if (lower === "individual") return "individual";
  // Known organization ULIDs — extend here if backend re-seeds
  const orgIds = [
    "01k2mjqx9zmjpjsaptg6gvqyf6", // old org ID
    "01kthe1t07dcawbb0r65w0v7w3",  // current org ID
  ];
  return orgIds.includes(lower) ? "company" : "individual";
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthUser: (
      state,
      action: PayloadAction<{ token: string; user?: any; admin?: any }>
    ) => {
      const payloadUser = action.payload.user;
      // Some endpoints (e.g. /me) return a smaller user than /login. When a field is
      // missing from the payload, keep what we already know instead of resetting it —
      // otherwise a KYC-verified company "loses" its verification and the KYC popup
      // comes back after the next page change or refresh. An explicit value still wins.
      // Only ever carry values over for the same user — never into a different account.
      const prev = payloadUser && state.user && String(state.user.id) === String(payloadUser.id) ? state.user : null;
      const prevCompany = prev?.company ?? null;
      const payloadCompany = payloadUser?.company === undefined ? prevCompany : payloadUser.company;
      state.token = action.payload.token;
      state.user = payloadUser
        ? {
          id: payloadUser.id || "",
          name: payloadUser.name || "",
          email: payloadUser.email || "",
          account_type: resolveAccountType(payloadUser.account_type),
          is_head_of_org: payloadUser.is_head_of_org || false,
          branches: payloadUser.branches || [],
          role: payloadUser.role || "",
          user_name: payloadUser.user_name || "",
          is_2fa_enabled: payloadUser.is_2fa_enabled ?? 0,
          profile_image: payloadUser.profile_image || "",
          preference: payloadUser.preference || { notify_email: 0, notify_inapp: 0 },
          has_branch: payloadUser.has_branch ?? 0,
          kyc_verification: payloadUser.kyc_verification ?? prev?.kyc_verification ?? false,
          is_feedback_popup: payloadUser.is_feedback_popup ?? false,
          company: payloadCompany
            ? {
              id: payloadCompany.id || prevCompany?.id || "",
              name: payloadCompany.name || prevCompany?.name || "",
              company_logo: payloadCompany.company_logo || prevCompany?.company_logo || "",
              subscription_status: payloadCompany.subscription_status || prevCompany?.subscription_status || "",
              kyc_verification: payloadCompany.kyc_verification ?? prevCompany?.kyc_verification ?? false,
              kyc_status: payloadCompany.kyc_status !== undefined ? payloadCompany.kyc_status : prevCompany?.kyc_status ?? null,
              latestSubscription_plan:
                payloadCompany.latestSubscription_plan !== undefined
                  ? payloadCompany.latestSubscription_plan
                  : prevCompany?.latestSubscription_plan ?? null,
            }
            : null,
        }
        : null;
      state.admin = action.payload.admin ?? null;
      state.permissions =
        payloadUser?.permissions !== undefined || !prev
          ? payloadUser?.permissions?.map((p: any) => p.name) || []
          : state.permissions;
      state.isAdmin =
        payloadUser?.is_head_of_org !== undefined || !prev
          ? !!payloadUser?.is_head_of_org && payloadUser.is_head_of_org === payloadUser.id
          : state.isAdmin;
    },
    // Fresh KYC result from GET /company/get-company (same rule as login: true only when approved).
    setCompanyKyc: (
      state,
      action: PayloadAction<{ kyc_verification: boolean; kyc_status: string | null }>
    ) => {
      if (!state.user) return;
      const { kyc_verification, kyc_status } = action.payload;
      state.user.kyc_verification = kyc_verification;
      if (state.user.company) {
        state.user.company.kyc_verification = kyc_verification;
        state.user.company.kyc_status = kyc_status;
      }
    },
    clearAuthUser: (state) => {
      state.token = "";
      state.user = null;
      state.admin = null;
      state.permissions = [];
      state.isAdmin = false;
    },
  },
});

export const { setAuthUser, setCompanyKyc, clearAuthUser } = authSlice.actions;
export const authSliceReducer = authSlice.reducer;
export const selectUser = (state: RootState) => state.auth.user;
export const selectAdmin = (state: RootState) => state.auth.admin;
export const selectToken = (state: RootState) => state.auth.token;
export const selectPermissions = (state: RootState) => state.auth.permissions;
export const selectIsAdmin = (state: RootState) => state.auth.isAdmin;
export const selectAuthUser = (state: RootState) => state.auth;
export const selectAuth = (state: RootState) => state.auth;